import {
  showSponsorAddressEntry,
  showSponsorAddressPrefill,
  showSponsorContactInfoEntry,
  showSponsorContactInfoPrefill,
} from '../../utils/helpers';
import contactInformation from './contactInformation';
import contactInformationPrefill from './contactInformationPrefill';
import mailingAddress from './mailingAddress';
import mailingAddressPrefill from './mailingAddressPrefill';
import sectionOverview from './sectionOverview';

export const sponsorPages = {
  sponsorInformationOverview: {
    path: 'veteran-information-overview',
    title: 'Veteran information',
    ...sectionOverview,
  },
  sponsorMailingAddressPrefill: {
    path: 'veteran-mailing-address-on-file',
    title: 'Your mailing address',
    depends: showSponsorAddressPrefill,
    ...mailingAddressPrefill,
  },
  sponsorMailingAddress: {
    path: 'veteran-mailing-address',
    title: 'Veteran’s mailing address',
    depends: showSponsorAddressEntry,
    ...mailingAddress,
  },
  sponsorContactInformationPrefill: {
    path: 'veteran-contact-information-on-file',
    title: 'Your contact information',
    depends: showSponsorContactInfoPrefill,
    ...contactInformationPrefill,
  },
  sponsorContactInformation: {
    path: 'veteran-contact-information',
    title: 'Veteran’s contact information',
    depends: showSponsorContactInfoEntry,
    ...contactInformation,
  },
};
